<template>
  <v-row dense>
    <v-col v-for="key in cards" :key="key">
      <v-card outlined class="p-3">
        <v-skeleton-loader type="avatar" class="mb-2" />
        <v-skeleton-loader type="text" />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ActivitySkeleton',
  props: {
    cards: { type: Number, default: 5 },
  },
}
</script>
